import * as React from 'react';
import { useSelector } from 'react-redux';
import { checkFsk, getNewBuildings } from '../../selectors';
import { ProjectsList as ProjectsListComponent } from '../../components/ProjectsList';
import { NewBuildingCard } from '../NewBuildingCard';
import { TViewMode } from '../Projects/types';
import { ShowMoreButton } from './ShowMoreButton';
import { getNewBuildingsForRender } from './helpers';
import { EmptyNewbuildingsBanner } from '../../components/EmptyNewbuildingsBanner';
import { trackShowMoreClick } from './tracking';
import { SPThemeWrapper } from '../../components/SPThemeWrapper';

interface IProjectsListProps {
  mode: TViewMode;
}

export function ProjectsList({ mode }: IProjectsListProps) {
  const [showAll, setShowAll] = React.useState(false);
  const {
    data: { list },
  } = useSelector(getNewBuildings);
  const isFsk = useSelector(checkFsk);
  const { newBuildingsForRender, hasMore } = getNewBuildingsForRender({ newBuildings: list, show: showAll, mode });
  const remainingNewBuildings = list.length - newBuildingsForRender.length;
  const projects = React.useMemo(
    () =>
      newBuildingsForRender.map((item, index) => (
        <NewBuildingCard key={item.id} newbuildingId={item.id} viewMode={mode} index={index} />
      )),
    [mode, newBuildingsForRender],
  );

  const handleShowMore = React.useCallback(() => {
    trackShowMoreClick();
    setShowAll(true);
  }, []);

  if (!newBuildingsForRender.length) {
    return <EmptyNewbuildingsBanner />;
  }

  return (
    <ProjectsListComponent
      list={projects}
      showMoreButton={
        hasMore ? (
          <SPThemeWrapper theme={isFsk ? 'fsk_stroke_primary' : undefined}>
            <ShowMoreButton length={remainingNewBuildings} onClick={handleShowMore} />
          </SPThemeWrapper>
        ) : null
      }
    />
  );
}
